import { useEffect, useState } from 'react';

import { Button, Group, Paper, Text } from '@optiro/ui';

import { initSentryReplay } from '@/lib/sentry';

import classes from './AnalyticsConsent.module.css';

const STORAGE_KEY = 'optiro-analytics-consent';

type ConsentState = 'pending' | 'granted' | 'denied' | 'unknown';

const isPrintRoute = () => window.location.pathname.startsWith('/print/');

export function AnalyticsConsent() {
  if (isPrintRoute()) return null;

  return <ConsentBanner />;
}

function ConsentBanner() {
  const [consent, setConsent] = useState<ConsentState>('pending');

  useEffect(() => {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    if (stored === 'granted' || stored === 'denied') {
      setConsent(stored);
    } else {
      setConsent('unknown');
    }
  }, []);

  const handleConsent = (value: 'granted' | 'denied') => {
    window.localStorage.setItem(STORAGE_KEY, value);
    if (value === 'granted') initSentryReplay();
    setConsent(value);
  };

  if (consent === 'pending' || consent === 'granted' || consent === 'denied') {
    return null;
  }

  return (
    <Paper className={classes.banner} shadow="xl" radius="lg" withBorder>
      <div>
        <Text fw={700} size="sm" c="#1f4029">
          Vi bruger cookies til fejlfinding
        </Text>
        <Text size="sm" mt={4} c="#2d5a4a">
          Vi bruger Sentry til at optage sessioner, så vi kan finde og rette fejl. Al tekst og alle
          billeder er skjult i optagelserne. Vores besøgsstatistik (Plausible) bruger ingen cookies
          og kræver ikke samtykke. Du kan når som helst trække din tilladelse tilbage ved at rydde
          cookies.
        </Text>
      </div>
      <Group gap="sm" mt={{ base: 'sm', md: 0 }} justify="flex-end">
        <Button variant="outline" color="dark" onClick={() => handleConsent('denied')}>
          Afvis
        </Button>
        <Button style={{ backgroundColor: '#3c735b' }} onClick={() => handleConsent('granted')}>
          Accepter
        </Button>
      </Group>
    </Paper>
  );
}
